import { useState } from "react";
import { useTranslation } from "react-i18next";

const items = ["1", "2", "3", "4", "5"];

export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<string | null>("1");

  return (
    <section id="faq" className="border-t border-background-200 bg-background-50">
      <div className="mx-auto max-w-3xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t("faq.title")}
          </h2>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {items.map((n) => {
            const isOpen = open === n;
            return (
              <div
                key={n}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : n)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-semibold text-foreground-900">
                    {t(`faq.q${n}`)}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} w-4 h-4 flex items-center justify-center`}
                    />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {t(`faq.a${n}`)}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}